import { render, staticRenderFns } from "./OfficeActivity.vue?vue&type=template&id=04a0517d&scoped=true&"
import script from "./OfficeActivity.vue?vue&type=script&lang=js&"
export * from "./OfficeActivity.vue?vue&type=script&lang=js&"
import style0 from "../../assets/style/base.css?vue&type=style&index=0&id=04a0517d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04a0517d",
  null
  
)

export default component.exports